import { render, staticRenderFns } from "./CardOrderActivateCards.vue?vue&type=template&id=2a193792&"
import script from "./CardOrderActivateCards.vue?vue&type=script&lang=js&"
export * from "./CardOrderActivateCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports